import React, {ReactNode} from 'react';
import {Content} from "../../../../App";

interface BasketPageSectionProps {
  image: string;
  gradientPosition: 'left' | 'right';
  title: string;
  subTitle: string;
  children: ReactNode;
  sideOverlay?: ReactNode;
  sideOverlayPosition?: 'left' | 'right';
}

const BasketPageSection = (props: BasketPageSectionProps) => {
  return (
    <>
      <div className="image-container md:30rem relative overflow-hidden border-round-2xl shadow-2" style={{
        backgroundImage: `url('${props.image}')`,
        maxHeight: '48vh',
        height: '40rem',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <div
          className="overlay"
          style={{
            background: `linear-gradient(to ${props.gradientPosition}, rgba(255,255,255,0.96), rgba(255,255,255,0.30), transparent)`,
          }}
        />

        <div className="absolute bottom-0 left-0 right-0 top-0 z-2">
          <Content className='h-full'>
            <div className="flex h-full flex-column justify-content-between">
                <div className="text-xl sm:text-2xl md:text-4xl font-bold mb-3">
                  <div className="flex">
                    <div className='bg-white color-orange px-3 p-2 md:p-3 border-round-left-xl'>{props.title}</div>
                    <div className='bg-orange text-white px-3 p-2 md:p-3 border-round-right-xl'>{props.subTitle}</div>
                  </div>
                </div>
              {props.sideOverlay && (
                <div className="hidden md:block mb-3 md:mb-4">
                  {props.sideOverlay}
                </div>
              )}

            </div>
          </Content>
        </div>
      </div>

      <Content className="mt-3 mb-5">
        {props.children}
        {props.sideOverlay && (
          <div className="block md:hidden mb-3">
            {props.sideOverlay}
          </div>
        )}
      </Content>
    </>
  );
};

export default BasketPageSection;
